export const convertToTitleCase = (name = "") =>
  name.toLowerCase().replace(/(\b[a-z])/g, (char) => char.toUpperCase());
